
import { takeLatest, call, put, select } from "redux-saga/effects"
import { SET_LOAD_BOUNTIES, FETCH_LOAD_BOUNTIES, FETCH_USER_BOUNTY_BUDGETS, SET_USER_BOUNTY_BUDGETS, DELETE_LOAD_BOUNTY } from "./actionTypes"
import { deleteLoadBounty, fetchLoadBounties, fetchUserBountyBudgets } from "./actions"
import { getLoadBountiesFilter } from "../rootReducer"


// TODO: add a filter on the fetch
function* workerFetchLoadBounties() {
  try {
    yield put({type: SET_LOAD_BOUNTIES, bounties: []})
    
    const filter = yield select(getLoadBountiesFilter)
    const resp = yield call(fetchLoadBounties, filter)
    
    if (resp?.data?.length) {
      yield put({type: SET_LOAD_BOUNTIES, bounties: resp.data})
    }
  } catch (err) {
    console.log('fetch load bounties error', err)
  }
}

// Really no need for a filter
function* workerFetchUserBountyBudgets() {
  try {
    yield put({type: SET_USER_BOUNTY_BUDGETS, budgets: []})
    const resp = yield call(fetchUserBountyBudgets)
    if (resp?.data?.length) {
      yield put({type: SET_USER_BOUNTY_BUDGETS, budgets: resp.data})
    }
  } catch (err) {
    console.log('fetch load bounties error', err)
  }
}

function* workerDeleteLoadBounty(payload) {
  const {bounty} = payload
  if (bounty?.id) {
    try {
      yield call(deleteLoadBounty, bounty)
      yield put({type: FETCH_LOAD_BOUNTIES})
      yield put({type: FETCH_USER_BOUNTY_BUDGETS})
      //TODO: Add some processing in here to verify and remove the bounty
      // might need to add filters to the reducer
    } catch (err) {
      console.error('error deleting load bounty', err)
    }
  }
}
  
export function* watchFetchLoadBountiesSaga() {
    yield takeLatest(FETCH_LOAD_BOUNTIES, workerFetchLoadBounties)
}

export function* watchFetchUserBountyBudgetsSaga() {
    yield takeLatest(FETCH_USER_BOUNTY_BUDGETS, workerFetchUserBountyBudgets)
}

export function* watchDeleteLoadBountySaga() {
  yield takeLatest(DELETE_LOAD_BOUNTY, workerDeleteLoadBounty)
}
